<template>
  <div class="z-40 flex">
    <div class="absolute bottom-0 w-full">
     <ControlStrip v-bind:state="state" v-on:change="$emit('change', $event)"/>

      <div class="flex flex-col max-w-4xl mx-auto">
        <ControlBar 
          v-bind:state="state" 
          v-bind:gallery="gallery" 
          v-on:change="$emit('change', $event)" 
          v-on:capture="$emit('capture')" 
          v-on:view-gallery="$emit('view-gallery')"/>
      </div>
    </div>
  </div>
</template>
<script>
const ControlBar = () => import("./controls/ControlBar");
const ControlStrip = () => import("./controls/ControlStrip");
export default {
  components: {
    ControlBar, ControlStrip
  },

  props: {
    gallery: {
      type: Array,
      default: () => []
    },
    state: {
      type: Object,
      default: null
    },
    forceShow: {
      type: Boolean,
      default: false
    }
  }
};
</script>
